const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3010/api";

/**
 * Product images are stored as server relative paths ("/uploads/products/x.png")
 * and served from the API host.
 */
export const productImageUrl = (image) => {
  if (!image) return null;
  if (image.startsWith("http")) return image;

  return `${API_BASE_URL}${image}`;
};
